import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbf07d7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card fadeIn" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "tx" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Id:", -1))
const _hoisted_5 = {
  key: 0,
  class: "tx"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Data size: ", -1))
const _hoisted_7 = {
  key: 1,
  class: "tx"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "warning" }, "Overflow Warning!", -1))
const _hoisted_9 = { class: "owner" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Owner:", -1))
const _hoisted_11 = { class: "deployingDate" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Created at:", -1))
const _hoisted_13 = { class: "description" }
const _hoisted_14 = { class: "actions" }

import ArweaveAddress from '@/components/atomic/ArweaveAddress.vue'
// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'BasicCard',
  props: {
	id: String,
	name: String,
	description: String,
	owner: String,
	deployingDate: String,
	dataSize: Number
},
  setup(__props) {

const props = __props;



function byte2kb(bytes: number) {
	return (bytes / 1024).toFixed(4);
}

function kb2mb(kb: number) {
	return (kb / 1024).toFixed(4);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.name), 1),
    _createElementVNode("p", _hoisted_3, [
      _createVNode(ArweaveAddress, {
        address: __props.id,
        isAddress: false
      }, {
        label: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["address"])
    ]),
    (__props.dataSize)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(__props.dataSize) + " bytes / " + _toDisplayString(byte2kb(__props.dataSize)) + " kb / " + _toDisplayString(kb2mb(byte2kb(__props.dataSize))) + " mb ", 1)
        ]))
      : _createCommentVNode("", true),
    (__props.dataSize && kb2mb(byte2kb(__props.dataSize)) >= 1)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(" Data size is too big. ")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_9, [
      _createVNode(ArweaveAddress, {
        address: __props.owner,
        isAddress: true,
        showProfileImage: true,
        showHandleInAddress: true
      }, {
        label: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["address"])
    ]),
    _createElementVNode("p", _hoisted_11, [
      _hoisted_12,
      _createTextVNode(" " + _toDisplayString(__props.deployingDate), 1)
    ]),
    _createElementVNode("p", _hoisted_13, _toDisplayString(__props.description), 1),
    _createElementVNode("p", _hoisted_14, [
      _createVNode(_component_router_link, {
        class: "btn",
        to: `/?workspace=${ __props.id }`,
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" OPEN IN ArCode ")
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}
}

})